import React, { useState } from "react";
import { Flex, Text, LinkIcon, AddIcon, Checkbox } from "@fluentui/react-northstar";

const presenceItems = [
  { color: "#107c10", label: "Verfügbar" },
  { color: "#d13438", label: "Beschäftigt" },
  { color: "#F7A827", label: "Abwesend" },
  { color: "#8a8a8a", label: "Offline" },
];

const linkItems = [
  { color: "#107c10", label: "Verknüpft & aktiv" },
  { color: "#F7A827", label: "Verknüpft, inaktiv" },
  { color: "#8a8a8a", label: "Nicht verknüpft" },
];

const actionItems = [
  {
    type: "toggle",
    label: "Aktiv / Inaktiv",
    description: "Aktiviert oder deaktiviert die Präsenz-Synchronisierung. Voraussetzung: ebuero-Zuordnung muss zuerst ausgewählt sein.",
  },
  {
    type: "link",
    label: "Verknüpfungsstatus",
    description: "Zeigt den aktuellen Status an — Grün: verknüpft & aktiv, Gelb: verknüpft aber inaktiv, Grau: nicht verknüpft.",
  },
  {
    type: "add",
    label: "Mitarbeiter anlegen",
    description: "Erstellt einen neuen Mitarbeiter im ebuero-System. Nur sichtbar, wenn noch keine Zuordnung besteht.",
  },
];

const containerStyle = {
  background: "rgba(98, 100, 167, 0.04)",
  padding: "6px 12px",
  borderRadius: "6px",
};

const helpContainerStyle = {
  background: "rgba(98, 100, 167, 0.06)",
  padding: "10px 14px",
  borderRadius: "6px",
  marginTop: "6px",
};

const dotStyle = (color) => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: color,
  flexShrink: 0,
});

const chainStyle = (color) => ({
  width: 10,
  height: 10,
  borderRadius: 2,
  backgroundColor: color,
  flexShrink: 0,
  position: "relative",
});

const actionRowStyle = {
  padding: "4px 0",
};

const actionIconBoxStyle = {
  width: 24,
  height: 24,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const workflowStyle = {
  marginTop: "8px",
  padding: "6px 10px",
  background: "rgba(98, 100, 167, 0.08)",
  borderRadius: "4px",
  borderLeft: "3px solid #6264A7",
};

const toggleButtonStyle = {
  background: "none",
  border: "none",
  color: "#6264A7",
  cursor: "pointer",
  fontSize: "11px",
  padding: "2px 0",
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  fontWeight: 600,
};

function ActionIcon({ type }) {
  if (type === "toggle") {
    return (
      <span style={actionIconBoxStyle}>
        <Checkbox toggle checked={false} disabled styles={{ transform: "scale(0.7)", pointerEvents: "none" }} />
      </span>
    );
  }
  if (type === "link") {
    return (
      <span style={{ ...actionIconBoxStyle, color: "#107c10" }}>
        <LinkIcon styles={{ "& svg": { fill: "#107c10" } }} />
      </span>
    );
  }
  if (type === "add") {
    return (
      <span style={{ ...actionIconBoxStyle, color: "#6264A7" }}>
        <AddIcon styles={{ "& svg": { fill: "#6264A7" } }} />
      </span>
    );
  }
  return null;
}

const IconLegend = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <Flex column>
      <Flex wrap gap="gap.medium" vAlign="center" style={containerStyle}>
        {presenceItems.map((item) => (
          <Flex key={item.label} vAlign="center" gap="gap.smaller">
            <span style={dotStyle(item.color)} />
            <Text size="small" style={{ fontSize: 11 }}>{item.label}</Text>
          </Flex>
        ))}
        {linkItems.map((item) => (
          <Flex key={item.label} vAlign="center" gap="gap.smaller">
            <span style={chainStyle(item.color)} />
            <Text size="small" style={{ fontSize: 11 }}>{item.label}</Text>
          </Flex>
        ))}
        <button
          style={toggleButtonStyle}
          onClick={() => setShowHelp(!showHelp)}
        >
          <span style={{ fontSize: 13 }}>ⓘ</span>
          {showHelp ? "Hilfe ausblenden" : "Hilfe anzeigen"}
        </button>
      </Flex>

      {showHelp && (
        <div style={helpContainerStyle}>
          <Text weight="semibold" size="small" style={{ fontSize: 12, color: "#1a1a2e", marginBottom: 6, display: "block" }}>
            Aktionen-Übersicht
          </Text>
          {actionItems.map((item) => (
            <Flex key={item.type} vAlign="center" gap="gap.small" style={actionRowStyle}>
              <ActionIcon type={item.type} />
              <Flex column style={{ minWidth: 0 }}>
                <Text weight="semibold" size="small" style={{ fontSize: 12 }}>{item.label}</Text>
                <Text size="small" style={{ fontSize: 11, color: "#605e5c" }}>{item.description}</Text>
              </Flex>
            </Flex>
          ))}
          <div style={workflowStyle}>
            <Text size="small" style={{ fontSize: 11 }}>
              <Text weight="bold" size="small" style={{ fontSize: 11 }}>Workflow: </Text>
              Zuordnung auswählen (rechte Spalte) → Sync aktivieren (Toggle) → Status prüfen (Verknüpfungssymbol)
            </Text>
          </div>
        </div>
      )}
    </Flex>
  );
};

export default IconLegend;
